import React from "react";
import "../css/inscripciones.css";
const precios = [
  { categoria: "Miembros de ASAEE", precio: "USD 200", enlace: "https://inscripcioneventos.utpl.edu.ec/enrollment/eyJwZXJpb2RvIjogIjIwMjYwMiIsInByb2dyYW1hIjogIkNPU0VfUDAiLCJjYXJyZXJhIjogIlhMSTEiLCJtYXRlcmlhIjogIkNPU0UiLCJjdXJzbyI6ICIxMTQ0Iiwibm9tYnJlQ3Vyc28iOiAiWExJIEpPUk4gU1VEIElORyBQUk8gQVNBRUUiLCJzb2JyZXBhc2FyQ3Vwb3MiOiAiTiJ9"},
  { categoria: "Profesionales", precio: "USD 250", enlace: "https://inscripcioneventos.utpl.edu.ec/enrollment/eyJwZXJpb2RvIjogIjIwMjYwMiIsInByb2dyYW1hIjogIkNPU0VfUDAiLCJjYXJyZXJhIjogIlhMSTIiLCJtYXRlcmlhIjogIkNPU0UiLCJjdXJzbyI6ICIxMTQ1Iiwibm9tYnJlQ3Vyc28iOiAiWExJIEpPUk4gU1VEIElORyBQUk8iLCJzb2JyZXBhc2FyQ3Vwb3MiOiAiTiJ9" },
  { categoria: "Profesionales sin ponencia y estudiantes de posgrado", precio: "USD 150", enlace:"https://inscripcioneventos.utpl.edu.ec/enrollment/eyJwZXJpb2RvIjogIjIwMjYwMiIsInByb2dyYW1hIjogIkNPU0VfUDAiLCJjYXJyZXJhIjogIlhMSTMiLCJtYXRlcmlhIjogIkNPU0UiLCJjdXJzbyI6ICIxMTQ2Iiwibm9tYnJlQ3Vyc28iOiAiWExJIEpPUk4gU1VEIElORyBQUk8gU05QIiwic29icmVwYXNhckN1cG9zIjogIk4ifQ==" },
  { categoria: "Estudiantes de grado", precio: "USD 100", enlace:"https://inscripcioneventos.utpl.edu.ec/enrollment/eyJwZXJpb2RvIjogIjIwMjYwMiIsInByb2dyYW1hIjogIkNPU0VfUDAiLCJjYXJyZXJhIjogIlhMSTQiLCJtYXRlcmlhIjogIkNPU0UiLCJjdXJzbyI6ICIxMTQ3Iiwibm9tYnJlQ3Vyc28iOiAiWExJIEpPUk4gU1VEIElORyBFU1RVRElBTlRFUyIsInNvYnJlcGFzYXJDdXBvcyI6ICJOIn0=" }
];

const beneficios = [
  "🍸 Cóctel de bienvenida",
  "🍽 Cena oficial del Día 2 del evento"
];

export default function Inscripciones() {
  return (
    <section className="inscripciones" id="inscripcion">
      
      <h2><b>Costos </b>de inscripción</h2>
    

      <div className="lista-precios">
        {precios.map((item, index) => (
          <div className="precio-card" key={index}>
            <span className="numero">{index + 1}</span>
            <div>
              <h3>{item.precio}</h3>
              <p>{item.categoria}</p>
              <a className="link-inscripcion" href={item.enlace}> Inscríbete aquí</a>
            </div>
          </div>
        ))}
      </div>

      <div className="beneficios">
        <h3>Beneficios para miembros de ASAEE y Profesionales</h3>
        <p>Los miembros tendrán acceso exclusivo a:</p>

        <ul>
          {beneficios.map((item, index) => (
            <p key={index}>{item}</p>
          ))}
        </ul>
      </div>


    </section>
  );
}